 
const BASE_URL = "https://mse6sdf79i.execute-api.us-east-1.amazonaws.com/dev/"
 
 
 
export const environment = {
    //Auth
    production: false,
    featureAPI:"https://otqxxdz1ce.execute-api.us-east-1.amazonaws.com/dev/chat",
    getSetMessages:"https://otqxxdz1ce.execute-api.us-east-1.amazonaws.com/dev/chat",
    getClientConfig:"https://spx0go8tra.execute-api.us-east-1.amazonaws.com/dev/getClientConfig",
    addUserFeedback:"https://6qfwjb7she.execute-api.us-east-1.amazonaws.com/dev/addUserFeedback",
    getEvent:"https://zbv7vs7zc6.execute-api.us-east-1.amazonaws.com/data/events",
  };
 